import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchLabWorksApi } from 'api/lab-works-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  labWorks: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchLabWorksListing = createAsyncThunk(
  'lab-works/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchLabWorksApi(paramsObj, '');
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

const LabWorksSlice = createSlice({
  name: 'labworks',
  initialState,
  reducers: {
    setLabWorksLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setLabWorksActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLabWorksListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchLabWorksListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.labWorks = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchLabWorksListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setLabWorksActiveColumn, setLabWorksLoading } = LabWorksSlice.actions;
export default LabWorksSlice.reducer;
